import routerOptions0 from "/usr/src/app/content/n3-promos-8f55252f-08bf-4adb-bfce-cff45b8162fe/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}